import { createContext } from "react";
import sensors from "sa-sdk-javascript";
import axios from "axios";
import Modal from "./components/Modal";

const CTX_STATE = createContext();
const CTX_DISPATCH = createContext();

// "https://test-api.steamboxs.com";  //测试
// "https://pre-api.steamboxs.com";  //准生产
const urlObj = {
	0: "https://api.steamboxs.com", //虚贝
	1: "https://api.wanjiayizhan.com", //玩家驿站
	2: "https://gg-api.wanjiayizhan.com", //云时
};

const creator = (type, payload, error) => {
	return {
		type,
		payload,
		error,
	};
};

class Request {
	constructor(param) {
		this.param = param;

		const BASE_URL = urlObj[this.param.source || 0];

		if (
			!(this.param.url.includes("http") || this.param.url.includes("https"))
		) {
			this.param.url = BASE_URL + this.param.url;
		}

		//虚贝默认带来源参数
		if (this.param.data && this.param.url.includes("steamboxs.com")) {
			let origin = "ybjsqapi01";
			if (this.param.url.includes("test-")) {
				origin = "member";
			}

			this.param.data.origin = origin;
		}

		if (this.param.method === "get" || !this.param.method) {
			this.param.params = this.param.data;
		}

		this.source = axios.CancelToken.source();

		this._axios = axios.create(this.param.option);
	}

	send() {
		return new Promise(async (resolve, reject) => {
			try {
				const res = await this._axios({
					...this.param,
					cancelToken: this.source.token,
				});

				if (res.status === 200) {
					resolve(res.data);
				} else {
					throw res.statusText;
				}
			} catch (error) {
				if (axios.isCancel(error)) {
					console.log("Request canceled");
				} else {
					reject(catchErrorHandle(error));
				}
			}
		});
	}

	cancel() {
		this.source.cancel();
	}
}

function catchErrorHandle(error) {
	if (typeof error === "string") {
		return error;
	} else if (typeof error === "object") {
		if (Object.prototype.toString.call(error) === "[object Error]") {
			return error.message;
		} else if (error.errorFields) {
			return error.errorFields.length === 0
				? "未知错误"
				: error.errorFields[0].errors[0];
		} else {
			return JSON.stringify(error);
		}
	} else {
		return "未知错误";
	}
}

function dateFormate(fmt, date) {
	date = date || new Date();
	var o = {
		"M+": date.getMonth() + 1,
		"D+": date.getDate(),
		"H+": date.getHours(),
		"m+": date.getMinutes(),
		"s+": date.getSeconds(),
		"q+": Math.floor((date.getMonth() + 3) / 3),
		S: date.getMilliseconds(),
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(
			RegExp.$1,
			(date.getFullYear() + "").substr(4 - RegExp.$1.length)
		);
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(
				RegExp.$1,
				RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
			);
		}
	}
	return fmt;
}

const getParam = function () {
	var Url = window.location.href;
	var u,
		g,
		StrBack = "";
	if (arguments[arguments.length - 1] === "#") u = Url.split("#");
	else u = Url.split("?");
	if (u.length === 1) g = "";
	else g = u[1];

	if (g !== "") {
		var gg = g.split("&");
		var MaxI = gg.length;
		var str = arguments[0] + "=";
		for (var xm = 0; xm < MaxI; xm++) {
			if (gg[xm].indexOf(str) === 0) {
				StrBack = gg[xm].replace(str, "");
				break;
			}
		}
	}
	return StrBack;
};

const toast = (data) => {
	const { title, msg } = data;

	window.mbQuery
		? window.mbQuery?.toast?.({
				title,
				body: msg,
		  })
		: sysMsg({
				msg,
		  });
};

const sysMsg = (data) => {
	const { icon = "warning", title = "系统提示", msg } = data;
	Modal.tips({
		icon: icon,
		contentHead: title,
		contentBody: msg,
		onOk: (c) => {
			c();
		},
		okText: "确定",
		cancelBtn: null,
	});
};

const log = (msg) => {
	window.mbQuery?.log?.(msg);
};

const openBrowser = (url) => {
	window.mbQuery
		? window.mbQuery?.openBrowser?.(url)
		: window.parent.postMessage(`openUrl:${url}`, "*");
};

const disCount = (origin, now) => {
	return Math.round(((origin - now) / origin) * 100);
};

const platformObj = {
	Steam: 1,
	Epic: 5,
	Uplay: 4,
	Origin: 2,
	Blizzard: 6,
	Cube: 7,
};

const protypeObj = {
	游戏账号: 8,
	游戏激活码: 7,
	Steam充值卡: 2,
	绝地求生G币: 11,
};

const indexObj = {
	0: "共享游戏",
	1: "游戏账号",
	2: "游戏激活码",
	3: "Steam充值卡",
	4: "绝地求生G币",
};

const checkLogin = (state, dispatch, callback) => {
	if (state.token) {
		callback();
	} else {
		if (window.mbQuery) {
			dispatch(creator("setLoginIsShow", true));
		} else {
			window.parent.postMessage("showLogin", "*");
		}
	}
};

const logOut = (dispatch, showLogin) => {
	dispatch(creator("setUserInfo", null));

	dispatch(creator("setToken", null));
	window.mbQuery?.setToken?.(null);

	exitGame();

	showLogin && checkLogin({}, dispatch, () => {});
};

const setOnProcessGame = (data) => {
	window.mbQuery?.setOnProcessGame?.(data);
};

const getOnProcessGame = () => {
	return new Promise(async (resolve) => {
		resolve((await window.mbQuery?.getOnProcessGame?.()) || {});
	});
};

const playGame = (data) => {
	window.mbQuery?.playGame?.(data);
};

const exitGame = () => {
	window.mbQuery?.exitGame?.();
};

const specialNavigate = (name, token, navigate, isWjyz, state) => {
	//iframe嵌套下路由跳转会导致刷新，所以每次必带token
	isWjyz &&
		(state = {
			...state,
			from: "wjyz",
		});

	navigate(`${name}${window.mbQuery ? `` : `?token=${token}`}`, {
		state,
	});
};

const TCaptcha = (opt, cb) => {
	var createTicket = function () {
		var appid = "";
		// 生成容灾票据或自行做其它处理
		var ticket =
			"terror_1001_" + appid + Math.floor(new Date().getTime() / 1000);

		return {
			ticket: ticket,
			randstr: "@" + Math.random().toString(36).substr(2),
		};
	};

	var callback = function (res) {
		sensors.track("captcha_process", {
			status: "pass",
		});

		var obj = {
			ticket: res.ticket,
			randstr: res.randstr,
		};

		if (res.errorCode) {
			obj = createTicket();
		}

		if (obj.ticket) {
			obj.ret = 0;
		} else {
			obj.ret = 2;
		}

		cb(obj);
	};

	try {
		sensors.track("captcha_process", {
			status: "load",
		});

		var ready = null;
		opt.ready && (ready = opt.ready);
		opt.ready = function () {
			sensors.track("captcha_process", {
				status: "show",
			});

			ready && ready();
		};

		var captcha = new window.TencentCaptcha("195704878", callback, opt);
		captcha.show();
	} catch (error) {
		sensors.track("captcha_process", {
			status: "load_fail",
		});

		callback({
			errorCode: 1001,
			errorMessage: "图形验证加载错误，请联系客服",
		});
	}
};

const refreshUserInfo = async (token, userInfo, dispatch, num = 5) => {
	//大会员需要等待虚贝响应
	try {
		let times = 0;
		const timer = setInterval(async () => {
			times++;

			const req = new Request({
				url: "/api/user/v1/infos",
				source: 2,
				headers: {
					token,
				},
				data: {},
			});

			const res = await req.send();

			if (userInfo) {
				if (
					res.base.code === "200" &&
					res.data?.totalMinutes !== userInfo.totalMinutes
				) {
					dispatch(creator("setUserInfo", res.data));
					clearTimeout(timer);
				}
			} else {
				if (times === num) {
					dispatch(creator("setUserInfo", res.data));
				}
			}

			if (times >= num) {
				clearInterval(timer);
			}
		}, 1000);
	} catch (error) {}
};

const countdown = (date, day = 30) => {
	const value =
		new Date(date).getTime() + day * 24 * 60 * 60 * 1000 - +new Date();

	if (value > 0) {
		return Math.ceil(value / (1000 * 60 * 60 * 24));
	} else {
		return 0;
	}
};

function uniqueString(length) {
	const characters =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let uniqueString = "";

	for (let i = 0; i < length; i++) {
		const randomIndex = Math.floor(Math.random() * characters.length);
		uniqueString += characters.charAt(randomIndex);
	}

	return uniqueString;
}

function isNumber(value) {
	return typeof value === "number" || !isNaN(parseFloat(value));
}

export {
	CTX_STATE,
	CTX_DISPATCH,
	creator,
	Request,
	catchErrorHandle,
	dateFormate,
	getParam,
	toast,
	sysMsg,
	log,
	openBrowser,
	disCount,
	platformObj,
	protypeObj,
	indexObj,
	checkLogin,
	logOut,
	setOnProcessGame,
	getOnProcessGame,
	playGame,
	exitGame,
	specialNavigate,
	TCaptcha,
	refreshUserInfo,
	countdown,
	uniqueString,
	isNumber,
};
